(function eventTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const previousEventTracker = global.NewHomeSource.Analytics.eventTracker;
  const configurations = {
    hasBeenAttached: false
  };
  const onTouchProperties = {
    startX: 0,
    startY: 0,
    distX: 0,
    distY: 0
  };

  function inspectEvent(event, target) {
    const inspectedElement = target || event.target;

    if (!inspectedElement || !inspectedElement.dataset || !inspectedElement.dataset.event) {
      if (inspectedElement.parentElement && inspectedElement.parentElement.tagName !== 'BODY') {
        inspectEvent(event, inspectedElement.parentElement);
      }

      return;
    }

    if (event.type === 'mousedown' && inspectedElement.dataset.eventType !== 'mousedown') {
      return;
    }

    if (event.type === 'touchend' && inspectedElement.dataset.eventType !== 'touchend') {
      return;
    }
    if (event.type === 'change' && inspectedElement.dataset.eventType !== 'change') {
      return;
    }

    const dataset = inspectedElement.dataset;

    for (let index = 0; index < configurations.totalHandlers; index += 1) {
      const handler = configurations.handlers[index].eventTracker;
      const validator = configurations.handlers[index].eventTrackerValidator;

      if (validator(dataset, inspectedElement)) {
        configurations.queue.pushTask(handler.bind(inspectedElement));
      }
    }

    if (inspectedElement.dataset.eventForget) {
      delete inspectedElement.dataset.event;
    }
  }

  /**
  * touchend event handler
  * @param  {event} event The touchstart event
  */
  function onTouchStartEvent(event) {
    onTouchProperties.startX = event.changedTouches[0].pageX;
    onTouchProperties.startY = event.changedTouches[0].pageY;
  }

  /**
   * touchend event handler
   * @param  {event} event The touchend event
   */
  function onTouchEndEvent(event) {
    onTouchProperties.distX = event.changedTouches[0].pageX - onTouchProperties.startX;
    onTouchProperties.distY = event.changedTouches[0].pageY - onTouchProperties.startY;

    if (Math.abs(onTouchProperties.distX) >= 7 || Math.abs(onTouchProperties.distY) >= 10) {
      return;
    }

    inspectEvent(event);
  }

  /**
  * on change event handler
  * @param  {event} event The on change event
  */
  function onChangeEvent(event) {
    let inspectedElement = event.target;

    if (!inspectedElement) {
      return;
    }

    if (inspectedElement.nodeName === 'SELECT') {
      inspectedElement = inspectedElement[inspectedElement.selectedIndex];
    }

    inspectEvent(event, inspectedElement);
  }

  /**
   * @constructs NewHomeSource.Analytics.EventTracker;
   *
   * @param {IdleQueue} eventsQueue that runs the tasks on idle periods.
   * @param {Array} handlers that will react to the impression tracking.
   */
  function EventTracker(eventsQueue, handlers) {
    configurations.queue = eventsQueue;
    configurations.handlers = [];

    const totalHandlers = handlers.length;

    for (let index = 0; index < totalHandlers; index += 1) {
      if (handlers[index] &&
        typeof handlers[index].eventTracker === 'function' &&
        typeof handlers[index].eventTrackerValidator === 'function') {
        configurations.handlers.push(handlers[index]);
      }
    }

    configurations.totalHandlers = configurations.handlers.length;
  }

  /**
   * @public
   * init: attaches a event listeners to the mousedown and click events.
   */
  EventTracker.init = function init() {
    if (configurations.hasBeenAttached) {
      return;
    }

    configurations.hasBeenAttached = true;

    // As in some places of the code developers break the bubbling behavior we listen for both events
    // mousedown and click. Only one of them will be handled, click as default and mousedown
    // when indicated as data attribute.
    document.addEventListener('touchstart', onTouchStartEvent, { passive: true });
    document.addEventListener('touchend', onTouchEndEvent, { passive: true });
    document.addEventListener('mousedown', inspectEvent, { composed: true, useCapture: true });
    document.addEventListener('click', inspectEvent, { composed: true, useCapture: true });
    document.addEventListener('change', onChangeEvent, { composed: true, useCapture: true });
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Analytics.eventTracker to the previous script.
   */
  EventTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.eventTracker = previousEventTracker;
    return EventTracker;
  };

  global.NewHomeSource.Analytics.eventTracker = EventTracker;
}(window));
